import {clientsClaim as workbox_core_clientsClaim} from '/Volumes/Extreme Pro/projects/versneld/library/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Volumes/Extreme Pro/projects/versneld/library/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "library/build/appassets/fonts/.gitkeep",
    "revision": "d41d8cd98f00b204e9800998ecf8427e"
  },
  {
    "url": "library/build/appassets/icons.5696665d.svg",
    "revision": "689ed263537242699b7f1933b7a1e3c5"
  },
  {
    "url": "library/build/appassets/img/diamand.d9d361ea.svg",
    "revision": null
  },
  {
    "url": "library/build/appassets/img/pe-logo.ce3853e0.svg",
    "revision": null
  },
  {
    "url": "library/build/appassets/img/placeholder.8da8e659.svg",
    "revision": null
  },
  {
    "url": "library/build/appmain.274f65df.css",
    "revision": null
  },
  {
    "url": "library/build/appmain.fe3ca0e8.js",
    "revision": null
  },
  {
    "url": "library/build/appmain.fe3ca0e8.js.LICENSE.txt",
    "revision": "131b7cd5bdb33d1246f3112e2a6ff43f"
  }
], {});








